import { aed } from "@/lib/format";
import {
  buildReportDocument,
  openReportPrint,
  periodMeta,
  resolveReportLetterhead,
  escapeReportHtml,
} from "@/lib/reportPrintShell";

function cell(value) {
  return value ? aed(value) : "";
}

export async function printTrialBalance(report, title = "Trial Balance", options = {}) {
  if (!report) return false;
  const withBranch = { ...report, branch_id: report.branch_id ?? options.branchId, all_branches: options.allBranches };

  const rows = (withBranch.rows || [])
    .map(
      (r) => `
      <tr>
        <td class="mono">${r.code}</td>
        <td>${r.name}</td>
        <td>${r.schedule || ""}</td>
        <td class="num">${cell(r.opening_debit)}</td>
        <td class="num">${cell(r.opening_credit)}</td>
        <td class="num">${cell(r.period_debit)}</td>
        <td class="num">${cell(r.period_credit)}</td>
        <td class="num">${cell(r.closing_debit)}</td>
        <td class="num">${cell(r.closing_credit)}</td>
      </tr>`,
    )
    .join("");

  const t = withBranch.totals || {};
  const company = await resolveReportLetterhead({ branchId: withBranch.branch_id, allBranches: withBranch.all_branches });

  const html = buildReportDocument({
    title,
    company,
    metaHtml: `${periodMeta(withBranch)}
    ${withBranch.schedule ? `<div><strong>Schedule:</strong> ${escapeReportHtml(withBranch.schedule)}</div>` : ""}
    <div><strong>Status:</strong> ${withBranch.is_balanced ? "Balanced" : "Out of balance"}</div>`,
    bodyHtml: `<table>
    <thead>
      <tr>
        <th>Code</th><th>Account</th><th>Schedule</th>
        <th>Op. Dr</th><th>Op. Cr</th><th>Per. Dr</th><th>Per. Cr</th><th>Cls. Dr</th><th>Cls. Cr</th>
      </tr>
    </thead>
    <tbody>${rows}</tbody>
    <tfoot>
      <tr>
        <th colspan="3">Totals</th>
        <th class="num">${aed(t.opening_debit)}</th>
        <th class="num">${aed(t.opening_credit)}</th>
        <th class="num">${aed(t.period_debit)}</th>
        <th class="num">${aed(t.period_credit)}</th>
        <th class="num">${aed(t.closing_debit)}</th>
        <th class="num">${aed(t.closing_credit)}</th>
      </tr>
    </tfoot>
  </table>`,
  });

  return openReportPrint(html);
}
